import { makeAcrylicFigureCvObj, svgToFile } from './priviate/core.js';
import { each, go } from 'fxjs/es';

const makeAcrylicFigureMaterial = async ({ svg_el, printable_canvas, hook_position_ratio, stand_bottom }) => {
  const printable_file = await new Promise((res) => {
    printable_canvas.toBlob(function (blob) {
      res(new File([blob], 'Acrylic_figure_printable_image', { type: 'image/png' }));
    });
  });
  const svg_product_materials = [
    {
      printable_file,
      original_cutting_line_svg_file: await svgToFile(svg_el),
    },
  ];
  const cv_obj = await makeAcrylicFigureCvObj({
    svg_el,
    printable_canvas,
    hook_position_ratio,
    stand_bottom,
  });
  return {
    cv_obj,
    svg_product_materials,
  };
};

export const nessMakeAcrylicFigureMaterial = async ({
  product_faces2,
  result,
  bottom,
  content_image_ratio,
}) => {
  const { stand_bottom, size } = bottom;
  const { cv_obj, svg_product_materials } = await makeAcrylicFigureMaterial({
    svg_el: result.cutlineSvgEl,
    printable_canvas: result.canvas,
    hook_position_ratio: {
      x: result.structurePoint.x / result.canvas.width,
      y: result.structurePoint.y / result.canvas.height,
    },
    stand_bottom,
  });
  const default_canvas_size = 860;
  const maximum_size = Math.round(default_canvas_size * content_image_ratio);
  /* 디폴트 마진 10% 를 생각해서 만든 40% 마진이 있는 썸네일 */
  go(
    product_faces2.value,
    each((pf) => {
      const width = cv_obj.width * cv_obj.scaleX;
      const height = cv_obj.height * cv_obj.scaleY;
      cv_obj.scaleToWidth2(Math.floor(cv_obj._data.real_width_cm * pf.px_per_1cm));
      if (width > height) {
        cv_obj.scaleToWidth2(maximum_size);
      } else if (height) {
        cv_obj.scaleToHeight2(maximum_size);
      }
      cv_obj.top = Math.round((default_canvas_size - cv_obj.getHeight()) / 2);
      cv_obj.left = Math.round((default_canvas_size - cv_obj.getWidth()) / 2);
      cv_obj.cid = 'c2323';
      pf.px_per_1cm = Number((cv_obj.getWidth() / cv_obj._data.real_width_cm).toFixed(2));
      pf.designs = [cv_obj.toObject()];
    }),
  );
  return svg_product_materials;
};
